import { useCallback } from 'react';
import './nuevoStroLight.css'
import axios from 'axios';
export default function MensajesSistemaCronologiaLight({ mensaje, user }) {
    const ocultarMensaje = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(`https://back.agsseguros.online/api/ocultarCronologia`,
            {
                id: mensaje.id
            }
        ).then(async (response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [mensaje]);
    const mostrarMensaje = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(
            `https://back.agsseguros.online/api/mostrarCronologia`,
            {
                id: mensaje.id
            }
        ).then(async (response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [mensaje]);
    const borrarMensaje = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(
            `https://back.agsseguros.online/api/borrarCronologia`,
            {
                id: mensaje.id
            }
        ).then(async (response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [mensaje]);
    return (
        <>
            {mensaje.borrar === 1 || mensaje.oculto === 1 ?
                <></>
                :
                <div className='containerMensajeFiltroSistemaLight'>
                    <div className='d-flex flex-column flex-grow-1 gap-1'>
                        <div className='d-flex align-items-center gap-2'>
                            <span className='cronologia-label'>Autor:</span>
                            <div className='textoMensajeSistemaAutor'>{mensaje.autor}</div>
                        </div>
                        <div className='textoMensajeSistemaDesc'>{mensaje.desc}</div>
                    </div>
                    <div className='d-flex align-items-center gap-3 ms-4 flex-shrink-0'>
                        <div className='textoMensajesSistemaFecha'>{mensaje.fecha} | {mensaje.hora}</div>
                        {user === 1 || user === 53 ?
                            <div className='d-flex gap-1.5 align-items-center'>
                                {mensaje.oculto === 1 ?
                                    <button className="cronologia-action-btn" onClick={(e) => mostrarMensaje(e)} title="Mostrar"><i className="bi bi-eye" style={{ fontSize: '16px' }}></i></button>
                                    :
                                    <button className="cronologia-action-btn" onClick={(e) => ocultarMensaje(e)} title="Ocultar"><i className="bi bi-eye-slash" style={{ fontSize: '16px' }}></i></button>}
                                <button className="cronologia-action-btn delete-btn" onClick={(e) => borrarMensaje(e)} title="Eliminar"><i className="bi bi-trash3" style={{ fontSize: '16px' }}></i></button>
                            </div>
                            : null}
                    </div>
                </div>
            }
        </>
    );
}
